import React, { useState, useEffect } from 'react';
import './ReferralModal.css';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const ReferralModal = ({ displayReferral, setDisplayReferral, referrer_your_name, set_referrer_your_name,
    referrer_name, set_referrer_name, referrer_address, set_referrer_address, referrer_email, set_referrer_email,
    referrer_comments, set_referrer_comments, updateQuoteInformation }) => {

    const [formErrors, setFormErrors] = useState({});

    const handleSubmit = () => {
        const errors = validateForm();
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            updateQuoteInformation();
            setDisplayReferral(false);
        }
    };

    const handleCancel = () => {
        setDisplayReferral(false);
    };

    function validateForm() {

        const errors = {};

        //Applicant Personal Information

        if (!referrer_your_name) {
            errors.referrer_your_name = "Your Name is required!";
        }
        if (!referrer_name) {
            errors.referrer_name = "Referrer's Name is required!";
        }
        if (!referrer_address) {
            errors.referrer_address = "Referrer's Address is required!";
        }

        return errors;
    }

    const closeBtn = (
        <button className="close" onClick={handleCancel} type="button">
            &times;
        </button>
    );

    return (
        <Modal isOpen={displayReferral} style={{ maxWidth: '900px' }} className="move-right" backdrop={true} centered>
            <ModalHeader close={closeBtn}>
                <div className="label_modal_title">Please give us the name of the person who referred you.
                    <br />We'd like to thank them!</div>
            </ModalHeader>
            <ModalBody >
                <div className="ml-2 mr-4">
                    <div className="form-group mb-2 row">
                        <label className="form-group-label referral-label col-12 col-md-3">
                            Your Name*
                        </label>
                        <input
                            className="inp_referral_1 col-12 col-md-9"
                            type="text"
                            value={referrer_your_name}
                            onChange={(e) => set_referrer_your_name(e.target.value)}
                        />
                        <p className="p3_error_txt">{formErrors.referrer_your_name}</p>
                    </div>
                    <div className="form-group mb-2 row">
                        <label className="form-group-label referral-label col-12 col-md-3">
                            Referrer's Name*
                        </label>
                        <input
                            className="inp_referral_1 col-12 col-md-9"
                            type="text"
                            value={referrer_name}
                            onChange={(e) => set_referrer_name(e.target.value)}
                        />
                        <p className="p3_error_txt">{formErrors.referrer_name}</p>
                    </div>
                    <div className="form-group mb-2 row">
                        <label className="form-group-label referral-label col-12 col-md-3">
                            Referrer's Address*
                        </label>
                        <input
                            className="inp_referral_1 col-12 col-md-9"
                            type="text"
                            value={referrer_address}
                            onChange={(e) => set_referrer_address(e.target.value)}
                        />
                        <p className="p3_error_txt">{formErrors.referrer_address}</p>
                    </div>
                    <div className="form-group mb-2 row">
                        <label className="form-group-label referral-label col-12 col-md-3">
                            Referrer's Email
                        </label>
                        <input
                            className="inp_referral_1 col-12 col-md-9"
                            type="text"
                            value={referrer_email}
                            onChange={(e) => set_referrer_email(e.target.value)}
                        />
                    </div>
                    <div className="form-group mb-2 row">
                        <label className="form-group-label referral-label col-12 col-md-3">
                            Comments
                        </label>
                        <div className="col-12 col-md-9 px-0">
                            <textarea
                                className="inp_referral_1 flex-1 text-box_input_referral"
                                style={{ minHeight: "100px" }}
                                value={referrer_comments}
                                onChange={(e) => set_referrer_comments(e.target.value)}
                            />
                            <small className="font-italic font-weight-light ml-3">"my daughter" or "my neighbor." </small>
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="actions">
                    <button className="btn_modal_cancel" onClick={handleCancel}>Cancel</button>
                    <button className="btn_modal_submit" onClick={handleSubmit}>Submit</button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default ReferralModal;